import request from '@/utils/request'

export function index(params) {
  return request({
      url: '/settings/staff_assent_reasons',
      method: 'get',
      params: params
  })
}

export function show(id) {
  return request({
      url: `/settings/staff_assent_reasons/${id}`,
      method: 'get'
  })
}

export function store(data) {
  return request({
      url: '/settings/staff_assent_reasons',
      method: 'post',
      data
  })
}

export function update(data) {
  return request({
      url: `/settings/staff_assent_reasons/${data.id}`,
      method: 'put',
      data
  })
}

export function destroy(id) {
  return request({
      url: `/settings/staff_assent_reasons/${id}`,
      method: 'delete',
  })
}
